import _ from 'lodash';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Col, Card, Row } from 'react-bootstrap';
// import BatchTransitionForm from './BatchTransitionForm';
import DealContext from './DealContext';
import DealNameCard from './deal/DealNameCard';
import DealDescCard from './deal/DealDescCard';
import TeamCard from './deal/TeamCard';
import NotesCard from './deal/NotesCard';
import ChartCard from './deal/ChartCard';
import HistoryCard from './deal/HistoryCard';
import CustomerCard from './deal/CustomerCard';
import BillingCustomerCard from './deal/BillingCustomerCard';
import LienholderCard from './deal/LienholderCard';
import CurrencyExchangeCard from './deal/CurrencyExchangeCard';
import DealControlCard from './deal/DealControlCard';
import VehicleList from './deal/VehicleList';
import ValuesCard from './deal/ValuesCard';
import BranchCard from './deal/BranchCard';
// import Avatar from '../user/Avatar';

const DealInformation = () => {
  const user = useSelector(state => state.app.user);
  const { roles } = useContext(DealContext);
  const isCanada = _.get(user, 'branch.country', '').toUpperCase() === 'CA';

  const { isOnTeam } = roles;

  return (
    <div className="deal-information">
      {!isOnTeam && (
        <div className="form-paragraph warning mt-2 mb-1">
          <i className="fa-solid fa-triangle-exclamation paragraph-icon" /> The information on this deal has been
          reduced. This will apply to a salesperson not assigned to any quotes under the deal.
        </div>
      )}
      <Row className="mt-1 p-2">
        <Col md={4} className="deal-column col-xxl-3">
          <DealNameCard />
          <DealDescCard />
          <BranchCard />
          <TeamCard />
          {isOnTeam && <NotesCard />}
        </Col>
        <Col md={4} className="deal-column col-xxl-3">
          <ChartCard />
          {isOnTeam && <HistoryCard />}
        </Col>
        <Col md={4} className="deal-flex-column col-xxl-6">
          <Row>
            <Col sm={12} md={12} lg={12} className="deal-column col-xxl-6">
              {isOnTeam && <ValuesCard />}
              {isOnTeam && <DealControlCard />}
              {isCanada === true && <CurrencyExchangeCard />}
              <CustomerCard />
              <BillingCustomerCard />
              <LienholderCard />
            </Col>
            <Col sm={12} md={12} lg={12} className="deal-column col-xxl-6">
              <Card>
                <Card.Body className="pb-0">
                  <Card.Title>Units</Card.Title>
                </Card.Body>
                <VehicleList />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DealInformation;
